"use client";

import Image from "next/image";
import { useState } from "react";
import { resolveCatalogAsset } from "@/lib/catalog";

type RepairSection = {
  key: string;
  title: string;
  image: string;
  html: string;
};

type RepairSectionsClientProps = {
  sections: RepairSection[];
};

export function RepairSectionsClient({ sections }: RepairSectionsClientProps) {
  const normalizedSections = sections.map((section) => ({
    ...section,
    image: resolveCatalogAsset(section.image),
    html: normalizeStorelandHtml(section.html)
  }));

  const [activeKey, setActiveKey] = useState(normalizedSections[0]?.key ?? "");
  const activeSection =
    normalizedSections.find((section) => section.key === activeKey) ?? normalizedSections[0];

  if (!activeSection) {
      return null;
  }

  return (
    <div className="repair-page">
      <div className="repair-tabs-grid">
        {normalizedSections.map((section) => {
          const isActive = section.key === activeSection.key;

          return (
            <button
              key={section.key}
              type="button"
              className={`repair-card-tab ${isActive ? "repair-card-tab--active" : ""}`}
              onClick={() => setActiveKey(section.key)}
            >
              <div className="repair-card-tab__media">
                {section.image ? (
                  <Image
                    alt={section.title}
                    height={124}
                    loading="lazy"
                    sizes="124px"
                    src={section.image}
                    width={124}
                  />
                ) : (
                  <div className="repair-card-tab__placeholder">{section.title.slice(0, 1)}</div>
                )}
              </div>
              <div className="repair-card-tab__title">{section.title}</div>
              <div className="repair-card-tab__action">
                <span>{isActive ? "Раздел открыт" : "Открыть раздел"}</span>
                <strong aria-hidden="true">→</strong>
              </div>
            </button>
          );
        })}
      </div>

      <section className="repair-content-card">
        <div className="repair-content-card__head">
          <h2>{activeSection.title}</h2>
        </div>
        <div
          className="repair-content prose-content"
          dangerouslySetInnerHTML={{ __html: activeSection.html }}
        />
      </section>
    </div>
  );
}

function normalizeStorelandHtml(html: string) {
  if (!html?.trim()) {
    return html;
  }

  return html.replace(
    /(https?:)?\/\/([a-z0-9.-]*storeland\.(?:net|ru))(\/[^"'\s)<>]+)/gi,
    (_match, protocol, host, pathname) =>
      resolveCatalogAsset(`${protocol || "https:"}//${host}${pathname}`)
  );
}
